import { createComponentStore } from '../../utils/createComponentStore';

export const TRIGGER_TYPE_RECORD_CREATED = 'RECORD_CREATED';
export const TRIGGER_TYPE_ANY_UPDATE = 'ANY_UPDATE';
export const TRIGGER_TYPE_SPECIFIC_COLUMN = 'SPECIFIC_COLUMN';

const keyAuto = () => {
  return 'db_update_' + (Math.floor(Math.random() * 90000000) + 10000).toString();
};

const initData = () => ({
  outputKey: keyAuto(),
  targetDatabaseId: null,
  databaseList: [],
  triggerType: TRIGGER_TYPE_ANY_UPDATE,
  monitoredColumnId: null,
  monitoredColumnName: null,
  columnList: [],
});

const onLoadData = (rawData) => {
  const data = { ...initData(), ...rawData };
  // v1 compat: migrate outputPlaceholderKey → outputKey
  if (data.outputPlaceholderKey && !rawData.outputKey) {
    data.outputKey = data.outputPlaceholderKey;
  }
  delete data.outputPlaceholderKey;
  if (!data.triggerType) {
    data.triggerType = TRIGGER_TYPE_ANY_UPDATE;
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'trigger_on_database_update',
  endpoint: 'trigger_on_database_update',
  registryKey: 'trigger_on_database_update',
  initData,
  onLoadData,
  extraActions: (set, get) => ({
    setTargetDatabaseId: (targetDatabaseId) => {
      const data = {
        ...get().data,
        targetDatabaseId,
        monitoredColumnId: null,
        monitoredColumnName: null,
      };
      set({ data });
    },

    setDatabaseList: (databaseList) => {
      const data = { ...get().data, databaseList: [...databaseList] };
      set({ data });
    },

    setOutputPlaceholderKey: (value) => {
      const data = { ...get().data, outputKey: value };
      set({ data });
    },

    setTriggerType: (triggerType) => {
      const data = { ...get().data, triggerType };
      if (triggerType !== TRIGGER_TYPE_SPECIFIC_COLUMN) {
        data.monitoredColumnId = null;
        data.monitoredColumnName = null;
      }
      set({ data });
    },

    setMonitoredColumn: (columnId, columnName) => {
      const data = { ...get().data, monitoredColumnId: columnId, monitoredColumnName: columnName };
      set({ data });
    },

    setColumnList: (columnList) => {
      const data = { ...get().data, columnList: [...columnList] };
      set({ data });
    },
  }),
});

export const getTriggerOnDatabaseUpdateStore = getStore;

export default defaultStore;
